import "./FullScreenVideo.scss";
import React, { useState, useCallback, useEffect } from "react";
import { MdClose, MdFastForward, MdFastRewind } from "react-icons/md";
import { Modal } from "react-bootstrap";
import { StateSetter } from "../utils/types";
import { Button, ButtonType } from "../Components/Button/Button";
import { ButtonFrameworkVariant } from "../Components/ButtonFramework/ButtonFramework";
import { IconButton } from "../Components/IconButton";
import { Spinner } from "../Components/Spinner";
import { Video } from "../Components/Video";
import { VideoInfo } from "./videoTutorialUtils";
import * as R from "ramda";
interface FullScreenVideoProps {
  setFullScreenVideo: StateSetter<boolean>;
  fullScreenVideo?: boolean;
  currentVideo?: VideoInfo;
  videoList?: VideoInfo[];
}

const FullScreenVideo = ({
  fullScreenVideo,
  setFullScreenVideo,
  videoList,
  currentVideo,
}: FullScreenVideoProps): JSX.Element => {
  const [viewingVideo, setViewingVideo] = useState<VideoInfo>();
  const [previousVideo, setPreviousVideo] = useState<VideoInfo>();
  const [nextVideo, setNextVideo] = useState<VideoInfo>();

  const updateVideoPointers = useCallback(
    (video: VideoInfo) => {
      if (videoList && videoList.length > 0) {
        const currentIndex = R.findIndex(R.propEq("title", video.title), videoList);
        setViewingVideo(videoList[currentIndex]);
        if (videoList.length > 1) {
          if (currentIndex === 0) {
            setPreviousVideo(videoList[videoList.length - 1]);
          } else {
            setPreviousVideo(videoList[currentIndex - 1]);
          }
          if (currentIndex === videoList.length - 1) {
            setNextVideo(videoList[0]);
          } else {
            setNextVideo(videoList[currentIndex + 1]);
          }
        }
      }
    },
    [videoList]
  );

  useEffect(() => {
    if (currentVideo) {
      updateVideoPointers(currentVideo);
    }
  }, [currentVideo, updateVideoPointers]);

  if (viewingVideo?.videoFile) {
    return (
      <Modal
        size="xl"
        className="fullScreenVideoContainer"
        show={fullScreenVideo}
        onHide={() => setFullScreenVideo(false)}
      >
        <Modal.Header className="fullScreenVideoHeader">
          <IconButton
            className="fullScreenVideoHolderButtonContainer"
            type={ButtonType.EMPTY}
            variant={ButtonFrameworkVariant.LEADING_ICON}
            icon={<MdClose className="fullscreenVideoExitButton" />}
            onClick={() => setFullScreenVideo(false)}
          >
            {""}
          </IconButton>
        </Modal.Header>
        <Video
          src={viewingVideo.videoFile}
          controls
          className="fullScreenVideo"
          poster={viewingVideo.thumbnailFile}
          unloader={<Spinner size={20} />}
        ></Video>
        <div className="fullScreenVideoContentContainer">
          <h2 className="fullScreenVideoTitle">{viewingVideo.title}</h2>
          {viewingVideo.content ? (
            <h3 className="fullScreenVideoContent">{viewingVideo.content}</h3>
          ) : null}
          {viewingVideo.uploadDate ? (
            <h4 className="fullScreenSmallText">{`Uploaded: ${viewingVideo.uploadDate}`}</h4>
          ) : null}
          {viewingVideo.videoCreator ? (
            <h4 className="fullScreenSmallText">{`Video Creator: ${viewingVideo.videoCreator}`}</h4>
          ) : null}
        </div>
        {previousVideo && nextVideo ? (
          <div className="fullScreenVideoNavigation">
            <Button
              className="fullScreenVideoPrevButton"
              type={ButtonType.EMPTY}
              variant={ButtonFrameworkVariant.LEADING_ICON}
              icon={<MdFastRewind />}
              onClick={() => updateVideoPointers(previousVideo)}
            >
              Prev
            </Button>
            <Button
              className="fullScreenVideoNextButton"
              type={ButtonType.EMPTY}
              variant={ButtonFrameworkVariant.TRAILING_ICON}
              icon={<MdFastForward />}
              onClick={() => updateVideoPointers(nextVideo)}
            >
              Next
            </Button>
          </div>
        ) : null}
      </Modal>
    );
  } else {
    return (
      <Modal
        size="xl"
        className="fullScreenVideoContainer"
        show={fullScreenVideo}
        onHide={() => setFullScreenVideo(false)}
      >
        <Modal.Header className="fullScreenVideoHeader">
          <IconButton
            className="fullScreenVideoHolderButtonContainer"
            type={ButtonType.EMPTY}
            variant={ButtonFrameworkVariant.LEADING_ICON}
            icon={<MdClose className="fullscreenVideoExitButton" />}
            onClick={() => setFullScreenVideo(false)}
          >
            {""}
          </IconButton>
        </Modal.Header>
        <div className="fullScreenContainerExitWidget">
          <Button
            className="exitWidgetButton"
            type={ButtonType.EMPTY}
            variant={ButtonFrameworkVariant.LEADING_ICON}
            icon={<MdClose />}
            onClick={() => setFullScreenVideo(false)}
          ></Button>
        </div>
        <div className="fullScreenVideoContentContainer">
          <h2 className="fullScreenVideoTitle">No Video Found</h2>
        </div>
      </Modal>
    );
  }
};

export default FullScreenVideo;
